import axios from 'axios';

export const getAnalytics = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/analytics`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }
    );
    
    console.log('Analytics response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Analytics service error:', error);
    throw error;
  }
}; 